var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09386 0.551577C8.47412 -0.183859 9.52587 -0.183859 9.90612 0.551577L12.3276 5.2348C12.4246 5.42246 12.5775 5.57537 12.7652 5.67241L17.4484 8.09386C18.1839 8.47412 18.1839 9.52587 17.4484 9.90612L12.7652 12.3276C12.5775 12.4246 12.4246 12.5775 12.3276 12.7652L9.90612 17.4484C9.52587 18.1839 8.47412 18.1839 8.09386 17.4484L5.67241 12.7652C5.57537 12.5775 5.42246 12.4246 5.2348 12.3276L0.551577 9.90612C-0.183859 9.52587 -0.183859 8.47412 0.551577 8.09386L5.2348 5.67241C5.42246 5.57537 5.57537 5.42246 5.67241 5.2348L8.09386 0.551577Z",
    fill: "#00FFA3",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star_1.f779387ce4bf7caf5eae6efc4d326aae.svg";
export { ForwardRef as ReactComponent };